import GenericEntity from "@/assets/Entities/GenericEntity";

export default class Contact extends GenericEntity {
    contacts: { contact: string, date: string }[] = [{date: '', contact: ''}];
    locations: { location: string, date: string }[] = [{date: '', location: ''}];
}